export const props = {
  modelValue: {
    type: String,
    required: true
  },
  letterGroupSize: {
    type: Number,
    default: 5
  }
}
